import React, { Component } from 'react';
import PhotoGalleryIcon from '../../images/homes/photo-gallery.svg';
import I18n from '~/utils/translations';
import SVG from 'react-inlinesvg';

export default class PhotoGalleryButton extends Component {
  render() {
    return (
      <div className="home-media-button">
        <SVG className="home-media-button__icon" src={PhotoGalleryIcon} />
        <p className="home-media-button__text">{I18n.t('pages.homes.gallery.photo_gallery_button')}</p>
      </div>
    );
  }
}
